var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-image", {
    staticClass: "ik-image-tag",
    staticStyle: { width: "40px", height: "40px" },
    attrs: { src: _vm.imageUrl, "preview-src-list": _vm.previewList },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }